import { useEffect, useState } from 'react';
import { apiJson } from '../api/client.js';
import { MailboxMeetingsList } from '../components/MailboxPanels.jsx';

export function MyMeetingsPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiJson('/api/my/meetings')
      .then(setData)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h2 style={{ marginTop: 0 }} data-tour="page-title">Meetings</h2>
      <p className="muted small">Upcoming video calls and calendar events with your agency.</p>
      {error ? <p className="err">{error}</p> : null}
      <MailboxMeetingsList data={data} loading={loading} />
    </div>
  );
}
